// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Date__pc_only___1Ky5V","sp_only":"Date__sp_only___3X1m5","date":"Date__date___5u6BL"};